module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"btn-see-results":"Voir les résultats"},"en":{"btn-see-results":"See results"},"de":{"btn-see-results":"Ergebnisse anzeigen"},"es":{"btn-see-results":"Ver los resultados"},"it":{"btn-see-results":"Vedere i risultati"},"nl":{"btn-see-results":"Resultaten bekijken"},"pt":{"btn-see-results":"Ver resultados"}}')
  delete Component.options._Ctor
}
